import React from 'react';
import PropTypes from 'prop-types';
import {reduce} from 'lodash';

const propTypes = {
  microScholarships: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.string.isRequired,
      minAmount: PropTypes.number.isRequired,
      maxAmount: PropTypes.number.isRequired,
    })
  ),
  following: PropTypes.bool.isRequired,
  achievementItems: PropTypes.arrayOf(
    PropTypes.shape({
      emoji: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      scholarshipType: PropTypes.string.isRequired,
    })
  ),
};

const amount = (microScholarships, achievementItems) => {
  const amountsMap = reduce(
    microScholarships,
    (amounts, microScholarship) => {
      amounts[microScholarship.type] = microScholarship.minAmount;
      return amounts;
    },
    {}
  );

  return reduce(
    achievementItems,
    (total, achievementItem) => total + (amountsMap[achievementItem.scholarshipType] || 0),
    0
  ).toLocaleString('en');
};

const AwardAmount = ({microScholarships, achievementItems, following}) => {
  const award = amount(microScholarships, achievementItems);

  if (award === '0') {
    return null;
  }

  return (
    <div
      className={`college-discovery-step-college-card-award-amount ${following ? 'following' : ''}`}
    >
      ${award}
      <span className="college-discovery-step-college-card-award-amount-asterisk">*</span>
    </div>
  );
};

AwardAmount.propTypes = propTypes;

export default AwardAmount;
